import React, { Dispatch, SetStateAction } from 'react'

import {
    handleAssetInfoController,
    TTicketContract,
} from '@controllers/EthereumController/Public/handleAssetInfoController'
import useMain from '@hooks/useMain'
import useNetworkWallet from '@hooks/useNetworkWallet'
import { getTransaction } from '@providers/utils/alchemy/getTransaction'
import { TAssetInfoResult } from '@types'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
import { WinterCheckout } from '@usewinter/checkout'

interface IUseWinter {
    showWinter: true
    setShowWinter: Dispatch<SetStateAction<boolean>>
}
const UseWinter: React.FC<IUseWinter> = ({ showWinter, setShowWinter }) => {
    const {
        state: {
            mainInit: { projectId },
            selectedSalesBehaviour,
            coupon,
        },
        operations: { setCurrentStep, setTransactionHash, setWarningMessage, setShouldWarning },
    } = useMain()

    const {
        operations: { handleMintResults, handleMetadataResults },
    } = useNetworkWallet()

    // eslint-disable-next-line react-perf/jsx-no-new-object-as-prop
    const parametersToMint = {
        fakturaSales: selectedSalesBehaviour.position,
        fakturaCategory: selectedSalesBehaviour.category,
        fakturaR: coupon.r,
        fakturaS: coupon.s,
        fakturaV: coupon.v,
    }
    // const web3 = provider.getCurrentProvider()
    const Ticket = '' as unknown as TTicketContract

    async function handleWindowEvent(event: any) {
        if (event.data === 'closeWinterCheckoutModal') {
            setShowWinter(false)
        }
        if (event.data.name === 'successfulWinterCheckout') {
            setTransactionHash(event.data.transactionhash)
            const receipt = getTransaction(event.data.transactionhash).then(receipts => {
                return (
                    receipts.data &&
                    receipts.data.receipts?.filter(
                        (receipt: { transactionHash: any }) => receipt.transactionHash === event.data.transactionhash,
                    )[0]
                )
            })
            await receipt.then(async receipt => {
                if (receipt) {
                    handleMintResults(receipt as unknown as Record<string, unknown> | TAssetInfoResult[])
                    const assetInfo = await handleAssetInfoController(receipt, Ticket)
                    handleMetadataResults(assetInfo)
                }
            })

            setShowWinter(false)
            setCurrentStep('confirming')
            setWarningMessage('Transfering your NFTs...')
            setShouldWarning(true)
        }
    }

    React.useEffect(() => {
        window.addEventListener('message', handleWindowEvent)
        return () => window.removeEventListener('message', handleWindowEvent)
    }, [handleWindowEvent])

    return (
        <WinterCheckout
            projectId={projectId}
            production={false}
            showModal={showWinter}
            extraMintParams={parametersToMint}
        />
    )
}

export default UseWinter
